import { combineReducers, configureStore } from "@reduxjs/toolkit";
import TabReducer from "../reducers/tabSplice";
import UserReducer from "../reducers/UserSplice"
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage

// Combine reducers
const rootReducer = combineReducers({
    user: UserReducer,
    tabsData: TabReducer,
});

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["user", "tabsData"] 
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

// Persistor
export const persistor = persistStore(store);

// Types
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
